const BROWSER_ENROLLMENT_STATES = {
    ACCEPTED: 'accepted',
    PENDING: 'pending',
    REJECTED: 'rejected',
    EXPIRED: 'expired',
    IN_REVIEW: 'in_review',
}

const HIBU_METADATA_KEYS = {
    ASSESSMENT_RB_CHECKS_ENFORCED_MODE: 'ASSESSMENT_RB_CHECKS_ENFORCED_MODE',
    ENROLLED_BROWSER_BANNER_ENABLED: 'ENROLLED_BROWSER_BANNER_ENABLED',
}

export { BROWSER_ENROLLMENT_STATES, HIBU_METADATA_KEYS }
